var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{staticStyle:{"background":"#383F61"}},[_c('Header'),_c('router-view',{staticClass:"px-1"}),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }